import { Auth } from "shared/@auth";
import React, { useState, useEffect } from "react";

import TabBar from "DreamStream/Shared/TabBar";
import Button from "shared/Button";
import Header from "../Shared/Header";
import { AddLosPluginModal } from "./LosTab/AddLosPluginModal/AddLosPluginModal";
import AddMetaPluginModal from "./PluginsMetaTab/AddMetaPluginModal";
import LosTab from "./LosTab";
import PinTab from "./PinTab";
import PluginsGroupsTab from "./PluginsGroupsTab";
import AddGroupPluginModal from "./PluginsGroupsTab/AddGroupPluginModal";
import PluginsMetaTab from "./PluginsMetaTab";
import styles from "./PluginsPage.module.css";

import Loader from "shared/Loader";
import {
  usePlugins,
  useAddGroupPlugin,
  useAddMetaPlugin,
  useAddLosPlugin,
} from "./usePlugins";

export function PluginsPage() {
  const [activeTitle, setActiveTitle] = useState("Group Plugins");
  const [modalOpened, setModalOpened] = useState(false);
  const [groupPlugins, setGroupPlugins] = useState([]);
  const [metaPlugins, setMetaPlugins] = useState([]);
  const [losPlugins, setLosPlugins] = useState([]);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const [tempData, setTempData] = useState(null);

  const { data, refetch, isLoading, losData, losLoading, losRefetch } =
    usePlugins("organizations");

  const { hasPermission } = Auth.useContainer();
  const canAdd = hasPermission("dreamstream.sync") ? true : false;

  useEffect(() => {
    // console.log("*** Plugins page - useEffect called ***");
    // console.log("*** useEffect - data ***");
    // console.log(data);
    // console.log("************************");

    if (data) {
      let filteredGroupPlugins = filterGroupPlugins(data);
      // console.log("*** useEffect - data - filterGroupPlugins ***");
      // console.log(filteredGroupPlugins);
      // console.log("************************");
      setGroupPlugins(filteredGroupPlugins);

      let filteredMetaPlugins = filterMetaPlugins(data);
      // console.log("*** useEffect - data - filteredMetaPlugins ***");
      // console.log(filteredMetaPlugins);
      // console.log("************************");
      setMetaPlugins(filteredMetaPlugins);
    }

    if (losData) {
      let filteredLOSPlugins = filterLOSPlugins(losData);
      // console.log("*** useEffect - data - filteredLOSPlugins ***");
      // console.log(filteredLOSPlugins);
      // console.log("************************");
      setLosPlugins(filteredLOSPlugins);
    }
  }, [data, losData]);

  useEffect(() => {
    data && setTempData(data);
  }, [data]);

  const refetchPage = () => {
    refetch();
    losRefetch();
    setIsRefreshing(false);
  };

  const onCreate = () => {
    setModalOpened(true);
  };

  const filterGroupPlugins = (data) => {
    let pluginGroups = [];

    if (data) {
      let organizationsWithPlugins = data.filter(
        (group) => group.pinLevel === 0 && group.plugins != null
      );
      organizationsWithPlugins.forEach((orgWithPlugin) => {
        orgWithPlugin.plugins.forEach((pluggedIntoOrg) => {
          pluggedIntoOrg.groups.forEach((pluggedIntoGroup) => {
            pluginGroups.push({
              id: pluggedIntoGroup._id,

              plugeeIBONumber: orgWithPlugin.iboNumber,
              plugeeName: orgWithPlugin.name,

              targetIBONumber: pluggedIntoOrg.iboNumber,
              targetOrganizationName: pluggedIntoOrg.organizationName,
              targetGroupId: pluggedIntoGroup.groupId,
              targetGroupName: pluggedIntoGroup.groupName,
              targetId: pluggedIntoOrg._id,

              asAdmin: pluggedIntoGroup.isAdmin,
            });
          });

          // TRY CHECKING
          // console.log("*** PLUG To GROUP***");
          // console.log(pluggedIntoOrg);
          // console.log("************************");
        });

        // TRY CHECKING
        // console.log("*** ORG WITH PLUGIN***");
        // console.log(orgWithPlugin.length);

        // console.log(orgWithPlugin);
        // console.log("************************");
      });
    }

    // TRY Checking
    // console.log("*** FilterGroup Plugins Data ***");
    // console.log(pluginGroups);
    // console.log("************************");

    return pluginGroups;
  };

  const filterMetaPlugins = (data) => {
    let metaGroups = [];

    if (data) {
      let organizationsWithMeta = data.filter(
        (group) => group.pinLevel !== 0 && group.meta != null
      );

      // console.log("*** organizationsWithMeta ***");
      // console.log(organizationsWithMeta);
      // console.log("************************");

      organizationsWithMeta.forEach((orgWithMeta) => {
        // console.log("*** orgsWithMeta ***");
        // console.log( orgWithMeta);
        // console.log("************************");

        orgWithMeta.meta.forEach((pluggedIntoOrg) => {
          // console.log("*** metaOrg ***");
          // console.log(pluggedIntoOrg);
          // console.log("************************");

          pluggedIntoOrg.groups.forEach((pluggedIntoGroup) => {
            // console.log("*** metaGroup ***");
            // console.log(pluggedIntoGroup);
            // console.log("************************");

            let plugeeBusinessType = "";
            if (orgWithMeta.pinLevel === 2) plugeeBusinessType = "Platinumship";
            else if (orgWithMeta.pinLevel === 3)
              plugeeBusinessType = "Emeraldship";
            else if (orgWithMeta.pinLevel === 4)
              plugeeBusinessType = "Diamonship";

            let targetBusinessType = "";
            if (pluggedIntoOrg.pinLevel === 2)
              targetBusinessType = "Platinumship";
            else if (pluggedIntoOrg.pinLevel === 3)
              targetBusinessType = "Emeraldship";
            else if (pluggedIntoOrg.pinLevel === 4)
              targetBusinessType = "Diamonship";

            metaGroups.push({
              id: pluggedIntoOrg._id,
              plugeeGroupId:
                orgWithMeta.groups && orgWithMeta.groups[0]
                  ? orgWithMeta.groups[0].groupId
                  : null,
              plugeeIBONumber: orgWithMeta.iboNumber,
              plugeeOrganizationId: orgWithMeta.organizationId,
              plugeeOrganizationName: orgWithMeta.organizationName,
              plugeeBusinessType,

              targetIBONumber: pluggedIntoOrg.iboNumber,
              targetOrganizationName: pluggedIntoOrg.organizationName,
              targetBusinessType,
              targetGroupId: pluggedIntoGroup.groupId,
              targetGroupName: pluggedIntoGroup.groupName,
              targetId: pluggedIntoOrg._id,

              asAdmin: pluggedIntoGroup.isAdmin,
            });
          });
        });
      });
    }

    // console.log(metaGroups);
    // console.log("************************");
    return metaGroups;
  };

  const filterLOSPlugins = (data) => {
    let losGroups = [];

    if (data) {
      data.map((item) => {
        let plugeeBusinessType = "",
          asPin = "";

        if (item.pinLevel === 2) {
          plugeeBusinessType = "Platinumship";
          asPin = "Platinum";
        } else if (item.pinLevel === 3) {
          plugeeBusinessType = "Emeraldship";
          asPin = "Emerald";
        } else if (item.pinLevel === 4) {
          plugeeBusinessType = "Diamonship";
          asPin = "Diamond";
        }

        if (item.plugins && item.plugins.length > 0) {
          item.plugins.forEach((plugin, pluginIndex) => {
            losGroups.push({
              id: item._id,
              plugeeIBONumber: item.iboNumber,
              plugeeOrganizationName: item.organizationName,
              plugeeGroupId:
                item.groups && item.groups[0] ? item.groups[0].groupId : null,
              plugeeBusinessType,
              targetIBONumber: plugin.iboNumber,
              targetOrganizationName: plugin.organizationName,
              targetId: plugin._id,
              targetGroupId:
                plugin.groups && plugin.groups.length > 0
                  ? plugin.groups[0].groupId
                  : "",
              targetGroupName:
                plugin.groups && plugin.groups.length > 0
                  ? plugin.groups[0].groupName
                  : "",
              // asPin,
              pluginIndex, // Track the plugin index
            });
          });
        }
      });
    }

    // console.log("*** LOSPlugins ***");
    // console.log(losGroups);
    // console.log("************************");

    return losGroups;
  };

  const filterPinPlugins = (data) => {
    return data;
  };

  // Add new group plugin
  const { addGroupPlugin } = useAddGroupPlugin();

  const createGroupPlugin = (groupPlugin) => {
    setIsRefreshing(true);
    addGroupPlugin.mutateAsync(groupPlugin).then(() => {
      refetchPage();
    });

    setModalOpened(false);
  };

  // Add new meta plugin
  const { addMetaPlugin } = useAddMetaPlugin();

  async function createMetaPlugin(metaPlugin) {
    setIsRefreshing(true);

    addMetaPlugin.mutateAsync(metaPlugin).then(() => {
      refetchPage();
    });

    setModalOpened(false);
  }

  // Add new LOS plugin
  const { addLosPlugin } = useAddLosPlugin();

  async function createLosPlugin(losPlugin) {
    setIsRefreshing(true);

    addLosPlugin.mutateAsync(losPlugin).then(() => {
      refetchPage();
    });

    setModalOpened(false);
  }

  return (
    <>
      <div className={styles.container}>
        <Header title="PLUGINS"></Header>
        <>
          {isRefreshing || isLoading || losLoading ? (
            <Loader />
          ) : (
            <>
              <div className={styles.tabBar}>
                <div className={styles.tabs}>
                  <TabBar
                    titleList={[
                      "Group Plugins",
                      "Meta Plugins",
                      "LOS Plugins",
                      "Pin Plugins",
                    ]}
                    activeTitle={activeTitle}
                    onChange={(value) => setActiveTitle(value)}
                  />
                </div>

                {canAdd && activeTitle !== "Pin Plugins" && (
                  <Button
                    className={styles.createButton}
                    onClick={() => onCreate()}
                  >
                    CREATE NEW
                  </Button>
                )}
              </div>
              <div className={styles.tabsContainer}>
                {activeTitle === "Group Plugins" && groupPlugins && (
                  <PluginsGroupsTab plugins={groupPlugins} />
                )}
                {activeTitle === "Meta Plugins" && metaPlugins && (
                  <PluginsMetaTab plugins={metaPlugins} />
                )}
                {activeTitle === "LOS Plugins" && losPlugins && (
                  <LosTab plugins={losPlugins} />
                )}
                {activeTitle === "Pin Plugins" && <PinTab />}
              </div>
            </>
          )}
          <AddLosPluginModal
            isOpen={modalOpened && activeTitle === "LOS Plugins"}
            onClose={() => setModalOpened(false)}
            onClick={createLosPlugin}
          />

          <AddMetaPluginModal
            isOpen={modalOpened && activeTitle === "Meta Plugins"}
            onClose={() => setModalOpened(false)}
            onClick={createMetaPlugin}
          />

          <AddGroupPluginModal
            isOpen={modalOpened && activeTitle === "Group Plugins"}
            onClose={() => setModalOpened(false)}
            onClick={createGroupPlugin}
          />
        </>
      </div>
    </>
  );
}
